import { IServerResponse, getFirstChildNode, IXmlNode } from '@/app-modules/server-communications';
import { BaseResponse } from '@/components/chat/_domain/server/base-response';
import { IAuthenticationResponse } from '@/app-modules/server-service';

class AuthenticationFailedResponse implements IAuthenticationResponse {
  public success: boolean;
  public reason: string;

  constructor(authNode: IXmlNode) {
    this.success = false;
    this.reason = authNode.attributes.reason;
  }
}

class AuthenticationSuccessResponse implements IAuthenticationResponse {
  public success: boolean;
  public username: string;

  constructor(authNode: IXmlNode) {
    this.success = true;
    this.username = authNode.attributes.user;
  }
}

class AuthenticationResponse extends BaseResponse<IAuthenticationResponse> {
  protected filter(response: IServerResponse): boolean {
    return /command="auth"/g.test(response.Contents);
  }

  protected map(response: IServerResponse): IAuthenticationResponse {
    const node: Nullable<IXmlNode> = getFirstChildNode(response.Contents);
    if (node === null) {
      throw new Error('Failed to map response');
    }

    return (node.name === 'auth')
      ? new AuthenticationFailedResponse(node)
      : new AuthenticationSuccessResponse(node);
  }
}

export { AuthenticationResponse };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat/_domain/server/auth-response.ts